module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/youtube-circle-256.ddd07b92b49bf149.png"+" 256w",
        images: [{path: "https://static.sniffspot.com/packs/img/youtube-circle-256.ddd07b92b49bf149.png",width: 256,height: 256}],
        src: "https://static.sniffspot.com/packs/img/youtube-circle-256.ddd07b92b49bf149.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/youtube-circle-256.ddd07b92b49bf149.png"},
        
        width: 256,
        height: 256
      }